import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { FlagsmithProvider } from 'flagsmith/react';
import flagsmith from 'flagsmith';
import './index.css';
import App from './App';

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Root element not found');

const ENV_KEY = import.meta.env['VITE_FLAGSMITH_ENV_KEY'] as string | undefined;

createRoot(rootElement).render(
  <StrictMode>
    {ENV_KEY ? (
      // Flagsmith provider — wraps the app so useFlag() works anywhere in the tree.
      // FLAGS load async; the app renders immediately with defaults (no loading flash).
      <FlagsmithProvider
        options={{ environmentID: ENV_KEY, cacheFlags: true, enableAnalytics: false }}
        flagsmith={flagsmith}
      >
        <App />
      </FlagsmithProvider>
    ) : (
      // No flag key configured — render without provider (all flags return false)
      <App />
    )}
  </StrictMode>,
);
